import type { Device, ThemeClasses } from "../types";
import { DeviceGridCard } from "./DeviceGridCard";
import { DeviceListRow } from "./DeviceListRow";
import { DENSE_LIST } from "../../../../shared";
import { formatIndexNumber } from "../utils/formatters";

interface DeviceListProps {
  devices: Device[];
  themeClasses: ThemeClasses;
  isDarkMode: boolean;
  selectedView: string;
  currentPage: number;
  itemsPerPage: number;
  onEdit: (device: Device) => void;
  onDetails: (device: Device) => void;
  onActivate?: (device: Device) => void;
  onDeactivate?: (device: Device) => void;
  onDelete?: (device: Device) => void;
  onTransfer?: (device: Device) => void;
  t: (key: string, options?: any) => string;
  isSelectionMode?: boolean;
  selectedIds?: Set<string>;
  onToggleSelection?: (device: Device) => void;
}

export function DeviceList({
  devices,
  themeClasses,
  isDarkMode,
  selectedView,
  currentPage,
  itemsPerPage,
  onEdit,
  onDetails,
  onActivate,
  onDeactivate,
  onDelete,
  onTransfer,
  t,
  isSelectionMode = false,
  selectedIds = new Set(),
  onToggleSelection,
}: DeviceListProps) {
  if (devices.length === 0) {
    return (
      <div
        className={`text-center h-full text-lg flex items-center justify-center py-12 ${themeClasses.textSecondary}`}
      >
        No hay dispositivos
      </div>
    );
  }

  if (selectedView === "grid") {
    return (
      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
        {devices.map((device, index) => {
          const globalIndex = (currentPage - 1) * itemsPerPage + index + 1;
          const indexNumber = formatIndexNumber(globalIndex);
          return (
            <DeviceGridCard
              key={device.id}
              device={device}
              themeClasses={themeClasses}
              isDarkMode={isDarkMode}
              indexNumber={indexNumber}
              onEdit={onEdit}
              onDetails={onDetails}
              onActivate={onActivate}
              onDeactivate={onDeactivate}
              onDelete={onDelete}
              onTransfer={onTransfer}
              t={t}
              isSelectionMode={isSelectionMode}
              isSelected={selectedIds.has(device.id)}
              onToggleSelection={onToggleSelection}
            />
          );
        })}
      </div>
    );
  }

  return (
    <div className={DENSE_LIST}>
      {devices.map((device, index) => {
        const globalIndex = (currentPage - 1) * itemsPerPage + index + 1;
        const indexNumber = formatIndexNumber(globalIndex);
        return (
          <DeviceListRow
            key={device.id}
            device={device}
            themeClasses={themeClasses}
            isDarkMode={isDarkMode}
            indexNumber={indexNumber}
            onEdit={onEdit}
            onDetails={onDetails}
            onActivate={onActivate}
            onDeactivate={onDeactivate}
            onDelete={onDelete}
            onTransfer={onTransfer}
            t={t}
            isSelectionMode={isSelectionMode}
            isSelected={selectedIds.has(device.id)}
            onToggleSelection={onToggleSelection}
          />
        );
      })}
    </div>
  );
}
